<template>
	<div>
		<div>
			<h2>新升编码规范 v2.8 </h2><br>
			&nbsp;&nbsp;本编码规范基于阿里巴巴、华为的开发手册，添加了新升团队的风格和规范，补充了一些细节。参训学员严格按照该开发规范开发，
以保证团队内风格统一，提高代码的可读性和可维护性。<br><br>

&nbsp;&nbsp;&nbsp;&nbsp; “任何卷入复杂事务的人都需要团队，团队中最重要就是遵守纪律”<br>
			<hr><br>
		</div>
		<div style="padding-left: 80px;" v-html="htmlData">
		 
		</div>
	</div>
</template>

<script>

import api from '@/api/system/dev-standards.js';


export default {
	name: 'dev-common',
	data() {
		return {
                 htmlData: ""

		};
	},

	methods: {

	},
	mounted() {
	 
			api.getStandardsApi({id:58}, response => {
				this.htmlData = response.data.content;
			})
	}
};
</script>

<style lang="scss" scoped="scoped"></style>
